import script from "./ExternalImageControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExternalImageControls.vue?vue&type=script&setup=true&lang=ts"

import "./ExternalImageControls.vue?vue&type=style&index=0&id=3ed986d0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ed986d0"]])

export default __exports__